import casting from "./casting.jpg";
import collection from "./collection.jpg";
import concept from "./concept.jpg";
import contact from "./contact.jpg";
import contents from "./contents.jpg";
import cover from "./cover.jpg";
import deliverables from "./deliverables.jpg";
import end from "./end.jpg";
import hair from "./hair.jpg";
import intro from "./intro.jpg";
import makeup from "./makeup.jpg";
import photography from "./photography.jpg";
import production from "./production.jpg";
import projectDetails from "./project-details.jpg";
import references from "./references.jpg";
import references2 from "./references2.jpg";
import schedule from "./schedule.jpg";
import styling from "./styling.jpg";
import title from "./title.jpg";
import usage from "./usage.jpg";

export const OPEN_AIR_PAGE_PREVIEWS: Record<string, string> = {
  casting,
  collection,
  concept,
  contact,
  contents,
  cover,
  deliverables,
  end,
  hair,
  intro,
  makeup,
  photography,
  production,
  "project-details": projectDetails,
  references,
  references2,
  schedule,
  styling,
  title,
  usage,
};